import Repository from '../Repository';
import { useToast } from 'vue-toastification';

const resource = '/proposal';
const toast = useToast();

export default {
	store(payload) {
		return Repository.post(`${resource}`, payload).then((response) => {
			toast.success(`Propuesta registrada correctamente.`);
			return response;
		});
	}
}